export default "__VITE_ASSET__DibkGKey__"